import './App.css';
import Main from './components/Main';
import Container from "react-bootstrap/Container";
import CacheBuster from 'react-cache-buster';
import * as Sentry from "@sentry/react";
import packageJson from '../package.json';
import ErrorFallback from "./components/ErrorFallback";

function App() {
  const isProduction = process.env.NODE_ENV === "production";
  
  return (
    <Sentry.ErrorBoundary fallback ={ErrorFallback}>
      <CacheBuster
          currentVersion={packageJson.version}
          isEnabled={isProduction}
          isVerboseMode={false}
      >
        <Container>
          <div className="App">
            <Main />
          </div>
        </Container>
      </CacheBuster>
    </Sentry.ErrorBoundary>
  );
}

export default App;
